import React from "react";
import CommonContainer from "../../components/shared/CommonContainer";
import {
  
  Heading,
  
  Stack,
  Text,
  Input,
  HStack,
  Button,
  
  StackDivider,
  Select,
} from "@chakra-ui/react";
import ConnectWalletForm from "../../components/freelancer/connect/ConnectWalletForm";

export default function FreelancerConnectPage() {
  const [connectOption, setConnectOption] = React.useState("10 For $1.50");
  const [connectWalletPage, setConnectWalletPage] = React.useState(false);
  if(connectWalletPage){
    
      <ConnectWalletForm />
    
  }
  return (
    <CommonContainer>
      {
        connectWalletPage ? <ConnectWalletForm /> : 
        (

      <Stack my={20}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", lg: "30px" }}
          pb={10}
        >
          Buy Connects
        </Heading>
        <HStack
          p={10}
          justifyContent={"space-between"}
          gap={10}
          alignItems="start"
          border="1px solid #c5c5c5"
          borderRadius={10}
          divider={<StackDivider />}
          flexDir={{base:"column",lg:"row"}}
        >
          <Stack w={{ base:"full",lg: "50%" }} gap={8}>
            <HStack justifyContent={"space-between"}>
              <Text
                fontSize={{ base: "18px", lg: "24px" }}
                fontWeight={"semibold"}
                color="rgba(0,0,0,0.81)"
              >
                Your available Connects:
              </Text>
              <Text
                fontWeight="medium"
                fontSize={{ base: "18px", lg: "24px" }}
                color="#777"
              >
                81
              </Text>
            </HStack>
            <Stack gap={2}>
              <Text
                fontSize={{ base: "18px", lg: "24px" }}
                fontWeight={"semibold"}
                color="rgba(0,0,0,0.81)"
              >
                Select the amount to buy:
              </Text>
              <Select
                placeholder=""
                size="lg"
                onChange={(e) => {
                  setConnectOption(e.target.value);
                }}
              >
                <option>10 For $1.50</option>
                <option>20 For $3.00</option>
              </Select>
            </Stack>

            <HStack justifyContent={"space-between"}>
              <Text
                fontSize={{ base: "18px", lg: "24px" }}
                fontWeight={"semibold"}
                color="rgba(0,0,0,0.81)"
              >
                Your account will be charged:
              </Text>
              <Text
                fontWeight="medium"
                fontSize={{ base: "18px", lg: "24px" }}
                color="#777"
              >
                {connectOption.split(" ")[2]}
              </Text>
            </HStack>
            <HStack justifyContent={"space-between"}>
              <Text
                fontSize={{ base: "18px", lg: "24px" }}
                fontWeight={"semibold"}
                color="rgba(0,0,0,0.81)"
              >
                Connects balance will be:
              </Text>
              <Text
                fontWeight="medium"
                fontSize={{ base: "18px", lg: "24px" }}
                color="#777"
              >
                {+connectOption.split(" ")[0] + 81}
              </Text>
            </HStack>
            <HStack justifyContent={"space-between"}>
              <Text
                fontSize={{ base: "18px", lg: "24px" }}
                fontWeight={"semibold"}
                color="rgba(0,0,0,0.81)"
              >
                Connects will expire on:
              </Text>
              <Text
                fontWeight="medium"
                fontSize={{ base: "18px", lg: "24px" }}
                color="#777"
              >
                07/25/2023
              </Text>
            </HStack>
          </Stack>
          <Stack w={{ base:"full", lg: "50%" }} gap={4}>
            <Text
              fontSize={{ base: "18px", lg: "24px" }}
              fontWeight={"semibold"}
              color="rgba(0,0,0,0.81)"
            >
              Promo Code
            </Text>
            <HStack gap={5}>
              <Input size="lg" py={6} />
              <Button bg="#C5C5C5" p={6} _hover={{ bg: "#C5C5C5" }}>
                Apply
              </Button>
            </HStack>
            <Text color="#8D7786" py={5}>
              This bundle of Connects will expire 1 year from today. Unused
              Connects rollover to the next month (maximum of 200).
              <br />
              <br />
              You're authorizing Upwork to charge your account. If you have
              sufficient funds, we will withdraw from your account balance. If
              not, the full amount will be charged to your primary billing
              method.
            </Text>
            <HStack justifyContent="end"  borderTop={"1px"} my={5} borderColor="#c5c5c5" py={10}>
            <Button bg="#C5C5C5" px={10} py={6} _hover={{ bg: "#C5C5C5" }}>
                Back
              </Button>
            <Button bg="brand.500"color="white" px={10} py={6} _hover={{ bg: "brand.500",color:"white" }} onClick={()=>{
              setConnectWalletPage(true)
            }}>
                Buy connects
              </Button>
            </HStack>
          </Stack>
        </HStack>
      </Stack>
        )
      }
    </CommonContainer>
  );
}
